export const COUNTERPARTY_PATH = "/counterparties/:id";
